<template>
  <div class="featured-slider-group">
    <div class="owl-carousel testimonial-slide featured-venues-slider owl-theme">
      <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
        <Slide v-for="record in AboutTestimonial" :key="record.id">
          <!-- Testimonials Item -->
          <div class="testimonial-group text-start">
            <div class="testimonial-review">
              <div class="rating-point">
                <i class="fas fa-star filled"></i>
                <i class="fas fa-star filled ms-1"></i>
                <i class="fas fa-star filled ms-1"></i>
                <i class="fas fa-star filled ms-1"></i>
                <i class="fas fa-star filled ms-1"></i>
                <span> 5.0</span>
              </div>
              <h5>{{ record.Title }}</h5>
              <p>
                {{ record.Topic }}
              </p>
            </div>
            <div class="listing-venue-owner">
              <a class="navigation">
                <img
                  :src="require(`@/assets/img/profiles/${record.Image}`)"
                  class="img-fluid"
                  alt="User"
                />
              </a>
              <div class="testimonial-content">
                <h5>{{ record.Name }}</h5>
                <a href="javascript:void(0);" class="btn btn-primary"> Badminton </a>
              </div>
            </div>
          </div>
          <!-- /Testimonials Item -->
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import AboutTestimonial from "@/assets/json/about-testimonial.json";
import Company from "@/assets/json/company.json";
export default {
  data() {
    return {
      AboutTestimonial: AboutTestimonial,
      Company: Company,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
